import useBrowserLayoutEffect from "./useBrowserLayoutEffect";

const useBodyScrollLock = (lock = true) => {
  const lockScroll = () => {
    document.body.style.overflow = "hidden";
  };

  const unlockScroll = () => {
    document.body.style.overflow = "auto";
  };

  useBrowserLayoutEffect(() => {
    // Prevent scrolling on mount
    if (lock) {
      lockScroll();
    }

    // Re-enable scrolling when component unmounts
    return () => {
      unlockScroll();
    };
  }, [lock]);
};

export default useBodyScrollLock;
